var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "welcome" } }, [
    _c("div", { staticClass: "content" }, [
      _c("div", { staticClass: "main-title" }, [
        _vm._m(0),
        _c("div", { staticClass: "main-num" }, [
          _vm._v(" " + _vm._s(_vm.num) + " "),
        ]),
      ]),
      _c("div", { staticClass: "stat-content" }, [
        _c(
          "div",
          {
            staticClass: "item-stat",
            on: {
              click: function ($event) {
                return _vm.toLink(1)
              },
            },
          },
          [
            _c("div", { staticClass: "num" }, [
              _vm._v(_vm._s(_vm.total.pendingCount)),
            ]),
            _c("div", { staticClass: "text" }, [_vm._v("我发起的")]),
          ]
        ),
        _c(
          "div",
          {
            staticClass: "item-stat",
            on: {
              click: function ($event) {
                return _vm.toLink(2)
              },
            },
          },
          [
            _c("div", { staticClass: "num" }, [
              _vm._v(_vm._s(_vm.total.processedCount)),
            ]),
            _c("div", { staticClass: "text" }, [_vm._v("我处理的")]),
          ]
        ),
        _c(
          "div",
          {
            staticClass: "item-stat",
            on: {
              click: function ($event) {
                return _vm.toLink(3)
              },
            },
          },
          [
            _c("div", { staticClass: "num" }, [
              _vm._v(_vm._s(_vm.total.ccToMeCount)),
            ]),
            _c("div", { staticClass: "text" }, [_vm._v("抄送给我的")]),
          ]
        ),
        _c(
          "div",
          {
            staticClass: "item-stat",
            on: {
              click: function ($event) {
                return _vm.toLink(4)
              },
            },
          },
          [
            _c("div", { staticClass: "num" }, [
              _vm._v(_vm._s(_vm.readCount.unread || 0)),
            ]),
            _c("div", { staticClass: "text" }, [_vm._v("未读通知")]),
          ]
        ),
      ]),
      _vm._m(1),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticStyle: {
          display: "flex",
          height: "22px",
          "margin-left": "16px",
          "padding-top": "24px",
        },
      },
      [
        _c("div", { staticClass: "title-line" }),
        _c("div", { staticClass: "title-name" }, [_vm._v("员工人数")]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "main-content" }, [
      _c("div", { staticStyle: { height: "350px" } }, [
        _c("img", {
          staticStyle: { width: "320px", height: "320px" },
          attrs: { src: require("../../assets/img_guihuazhong.png") },
        }),
        _c("div", { staticClass: "info" }, [_vm._v("功能规划中，敬请期待~")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }